import React from 'react';

interface GitHubLogoProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

const GitHubLogo: React.FC<GitHubLogoProps> = ({
  size = 24,
  color = '#066653',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      role='img'
      aria-labelledby='githubLogoTitle'
      {...props}>
      <title id='githubLogoTitle'>GitHub Logo</title>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 0C5.37 0 0 5.51 0 12.3035C0 17.75 3.44 22.35 8.21 23.9765C8.805 24.08 9.03 23.71 9.03 23.3921C9.03 23.1 9.02 22.13 9.02 21.1005C6 21.67 5.22 20.35 4.98 19.6549C4.845 19.3 4.26 18.21 3.75 17.917C3.33 17.69 2.73 17.12 3.73 17.1019C4.68 17.09 5.36 17.99 5.58 18.363C6.66 20.22 8.38 19.7 9.07 19.3781C9.18 18.58 9.49 18.04 9.84 17.7325C7.17 17.42 4.38 16.36 4.38 11.6576C4.38 10.32 4.84 9.21 5.61 8.35102C5.49 8.04 5.07 6.78 5.73 5.09058C5.73 5.09 6.74 4.77 9.03 6.3517C9.99 6.07 11.01 5.94 12.03 5.93645C13.05 5.94 14.07 6.07 15.03 6.3517C17.325 4.75 18.33 5.09 18.33 5.09058C18.99 6.78 18.57 8.04 18.45 8.35102C19.215 9.21 19.68 10.3 19.68 11.6576C19.68 16.38 16.88 17.42 14.21 17.7325C14.64 18.12 15.02 18.86 15.02 20.0086C15.015 21.65 15 22.98 15 23.3921C15 23.71 15.22 24.1 15.82 23.9765C18.2072 23.15 20.28 21.58 21.74 19.4882C23.2103 17.39 24 14.88 24 12.3035C24 5.51 18.63 0 12 0Z'
        fill={color}
      />
    </svg>
  );
};

export default GitHubLogo;
